<template>
  <div :class="$style.root" :style="{ width: `${size}px` }">
    <div :class="$style.container">
      <img v-if="src" :src="src" :alt="alt" :class="$style.img" />
      <i v-else :class="icon"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: 'Avatar'
    },
    size: {
      type: Number,
      default: 32
    },
    icon: {
      type: String,
      default: 'el-icon-user-solid'
    }
  }
}
</script>

<style lang="scss" module>
.root {
  display: inline-block;
  max-width: 100%;
  position: relative;
  border-radius: 50%;
  overflow: hidden;
  color: $--avatar-font-color;
  font-size: $--avatar-icon-font-size;

  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }
}

.container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $--avatar-background-color;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
